import { BET_CONFIG } from 'src/config'
import type { MarbleGame } from 'src/types/domain/Game'

export const getSettledTimeWindow = (game: MarbleGame): number => {
  return game.settledWindow ? game.settledWindow : BET_CONFIG.DEFAULT_SETTLED_WINDOW_SEC
}
